import PropTypes from 'prop-types';
import YachtDescriptionBlockWithLink from './YachtDescriptionBlockWithLink';
import YachtDescriptionBlock from './YachtDescriptionBlock';

const YachtInterpolatedDescription = ({
  professionalIds,
  professionalsMap,
  text: untrimmedText
}) => {
  const text = untrimmedText.replace(/^\| /, '').replace(/ \|$/, '');
  const renderedLinksMap = {};

  return (
    <>
      {text.split(' | ').map(block => {
        const splitBlock = block.split('{{professional:');

        return (
          <p key={block}>
            <YachtDescriptionBlock block={splitBlock[0]} />

            {splitBlock.slice(1, splitBlock.length).map(blockWithLink => {
              const professionalId = blockWithLink.split('}}')[0];
              const response = (
                <YachtDescriptionBlockWithLink
                  key={blockWithLink}
                  blockWithLink={blockWithLink}
                  renderLink={!renderedLinksMap[professionalId]}
                  professionalsMap={professionalsMap}
                />
              );
              renderedLinksMap[professionalId] = true;

              return response;
            })}
          </p>
        );
      })}
    </>
  );
};

YachtInterpolatedDescription.propTypes = {
  text: PropTypes.string.isRequired,
  professionalIds: PropTypes.array.isRequired,
  professionalsMap: PropTypes.object.isRequired
};

export default YachtInterpolatedDescription;
